module.exports = __webpack_public_path__ + "static/Mexico-e8cb570d62090efa22c223b98df0678d.jpg";